import React, { cloneElement } from "react";
import { RCCLov } from "react-common-components";
import ILovComponent from "react-common-components/dist/components/Lov/interface";
import { useTranslation } from "src/context/Translations/context";

const LovRiskStrategies: React.FC<Omit<ILovComponent, "valueProperty" | "labelProperty" | "routeAPI">> = ({
	name,
	control,
	extraParametersOnLoad,
	label,
	...rest
}) => {
	const { translate } = useTranslation();

	const optionComponent = (component:any,props:any) =>  
		  cloneElement(component,props,<span>{translate(props.data.label)}</span>);	

	return (
		<RCCLov 
			label={label}
			name={name} 
			control={control}
			routeAPI="RisksStrategies/Lov"
			valueProperty="Ria002Id"
 			labelProperty="Ria002Titulo"
		  componentsFunctions={{option:(x,y) => optionComponent(x,y), singleValue: (x,y) => optionComponent(x,y) }}
			elementsPerPage={20}

			extraParametersOnLoad={extraParametersOnLoad || ""}
			{...rest}
		/>
	);
};
	

export default LovRiskStrategies;
